import React from 'react';
import PropTypes from 'prop-types';
import css from './CheckedInOptions.css';
import StyledButton from '../common/StyledButton';
import Icon from 'SF/MaterialIcon';

const OptionButton = props => {
  return (
    <div className={css['option']}>
      <Icon icon={props.icon} aria-hidden='true'/>
      <StyledButton asLink onClick={props.onClick}>
        {props.text}
      </StyledButton>
    </div>
  );
};

OptionButton.propTypes = {
  icon: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default OptionButton;
